import React from 'react';

import { OnboardingFormData } from 'api/onboarding/types';
import { Alert, FormItem, Spin } from 'components/misc/helpers';
import HtmlRenderer from 'components/misc/HtmlRenderer';
import { useSurveyContent } from 'shared/hooks';
import VerticalSpaceContainer from 'uicontainers/_shared/container/VerticalSpaceContainer';
import Handlebars from 'uicontainers/apps/survey/_shared/handlebars/Handlebars';
import Heading from 'uicontainers/_shared/Heading';
import { removeAllHandlebars } from 'shared/helpers/handlebar';

import { getTermsElement, redirectToUrl } from './helpers';
import styles from './home.module.scss';
import { useHandleSubmit, useOnAlertClose, useOnboardingSelectors } from './hooks';
import NXForm from 'components/misc/NXForm';
import NXButton from 'components/misc/NXButton';

export const Home = () => {
  const [showWarning, setShowWarning] = React.useState(false);
  const { isOnboarding, redirect_to } = useOnboardingSelectors();
  const handleSubmit = useHandleSubmit();

  const { surveyContent } = useSurveyContent();

  const url = window.location.href;

  const onSubmit = (formData: OnboardingFormData) => handleSubmit(formData, setShowWarning);
  const handleOnAlertClose = useOnAlertClose(setShowWarning);

  React.useEffect(() => {
    redirectToUrl(redirect_to as string);
  }, [redirect_to]);

  return (
    <Spin spinning={isOnboarding} size="large">
      <VerticalSpaceContainer>
        {/* heading */}
        <Heading
          text={removeAllHandlebars(surveyContent?.content?.heading ?? null) || ''}
          data-test-id="onboarding-heading"
        />
        {/* subheading */}
        <HtmlRenderer
          content={removeAllHandlebars(surveyContent?.content?.subheading ?? null) || ''}
        ></HtmlRenderer>
        <div className={styles.form}>
          <NXForm
            initialValues={{
              did_accept_terms: false,
              survey_request_url: url,
            }}
            autoComplete="off"
            colon={false}
            requiredMark={false}
            labelAlign="left"
            layout="vertical"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 24 }}
            onFinish={onSubmit}
          >
            {getTermsElement(surveyContent)}

            <i style={{ fontSize: '16px' }}>
              By proceeding, you confirm all responses are based solely on your own knowledge and
              experience with no use of AI tools or outside research. This study may include a
              screener; if you do not qualify or if you use AI tools, you will not be eligible for
              compensation, and each study can only be completed once.
            </i>

            <FormItem hidden={true} name="survey_request_url"></FormItem>

            <FormItem>
              <NXButton type="primary" htmlType="submit">
                Continue
              </NXButton>
            </FormItem>
          </NXForm>

          {showWarning && (
            <Alert
              message="Please accept terms and conditions to proceed to survey"
              type="warning"
              showIcon
              closable
              onClose={handleOnAlertClose}
              data-test-id="onboarding-alert"
            />
          )}
        </div>

        <Handlebars />
      </VerticalSpaceContainer>
    </Spin>
  );
};

export default Home;
